import {mapActions, mapGetters} from "vuex";
import VideoPlayer from "@/components/video-player/index.vue";

export default {
    name: 'action-plan-step',
    props: {
        index: {
            type: Number
        },
        item: {},
        listLength: {
            type: Number
        }
    },
    data() {
        return {}
    },
    components: {
        VideoPlayer
    },
    computed: {
        formattedIndex() {
            return this.index >= 10 ? this.index : '0' + this.index
        },
        ...mapGetters({
            activeStep: 'actionPlans/activeStep',
            currentItem: 'actionPlans/currentItem',
            isProgressLoading: 'actionPlans/isProgressLoading',
        }),
        statusProgressItem() {
            if (!this.currentItem.userActionPlan.data.hasOwnProperty('status') || this.currentItem.userActionPlan.data.completedSteps === 0) return '';
            return this.currentItem.userActionPlan.data.status
        },
    },
    methods: {
        ...mapActions({
            updateProgress: 'actionPlans/UPDATE_PROGRESS',
        }),
        stepTo(direction) {
            this.$emit('step-to', {
                direction: direction,
                index: this.index
            })
        },
        navigateToList() {
            try {
                this.$router.push({name: 'action-plans'})
            } catch (e) {
                console.log(e);
            }
        },
        completeItem() {
            this.updateProgress({
                id: this.currentItem.id,
                type: 'complete',
                _method: 'patch'
            });
        },
    },

}
